<template>
	<div class="htmlBox">
		<h4 class="title">请输入要绑定的手机号</h4>
		<article class="tips">如果当前页面未完成退出将不会修改绑定</article>
		<div class="userinfo">
			<ul>
				<li>
					<p>手机号</p>
					<input type="tel" placeholder="请输入手机号" v-model="phone" />
				</li>
				<li>
					<p>短信验证码</p>
					<input class="w200" type="num" name="" id="" value="" placeholder="请输入验证码" v-model="code" />
					<em @click="getcode()" v-if="sign == false">发送验证码</em>
					<em v-else style="background:#BBBBBB;color:#fff ">{{ codehtml }}S</em>
				</li>
			</ul>
		</div>
		<button :disabled="btnState == false" :class="{ btnBg: btnState }" @click="sure()">确定</button>
	</div>
</template>

<script>
import { sendRequest } from '@/assets/public';
import { Toast } from 'vant';
export default {
	data() {
		return {
			phone: '', //手机号
			code: '', //验证码
			sign: false, //是否点击获取验证码按钮
			time: '', //倒计时
			isClick: false,
			codehtml: ''
		};
	},

	methods: {
		// 获取验证码
		async getcode() {
			if (!/^1[3456789]\d{9}$/.test(this.phone)) {
				Toast('手机号码有误');
				return false;
			} else {
				let res = await sendRequest('user/newMobileSms', { phone_mob: this.phone });
				if (res.status == 200) {
					this.codehtml = 60;
					this.sign = true;
					let tim = setInterval(() => {
						this.codehtml = this.codehtml - 1;
						if (this.codehtml <= 0) {
							clearInterval(tim);
							this.sign = false;
							return false;
						}
					}, 1000);
					this.time = tim;
				} else {
					Toast(res.msg);
				}
			}
		},
		// 提交
		async sure() {
		
			if (this.isClick == false) {
				if (this.phone == '') {
					Toast('请输入手机号');
					this.isClick = false;
				} else if (this.code == '') {
					Toast('请输入验证码');
					this.isClick = false;
				} else {
					let res = await sendRequest('user/newMobileSmsCheck', { phone_mob: this.phone, code: this.code });
				
					if (res.status != 200) {
						Toast(res.msg);
						this.isClick = false;
					} else {
						this.isClick = true;
						Toast('修改成功');
						setTimeout(() => {
							this.$router.push({ path: '/personalCenter' });
						}, 2000);
					}
				}
			}
		}
	},
	computed: {
		btnState() {
			//当用户名和密码框都不为空时btnState==true,利用这个计算属性来动态控制按钮的禁用和颜色
			return this.phone !== '' && this.code !== '';
		}
	}
};
</script>
<style scoped>
/*button禁用时的背景颜色*/
button {
	width: 13.6rem;
	height: 2rem;
	background: rgba(221, 221, 221, 1);
	border-radius: 0.2rem;
	position: absolute;
	bottom: 1.6rem;
	left: 0.7rem;
	line-height: 2rem;
	font-size: 0.6rem;
	color: #fff;
	border: none;
}
/*button可用时的背景颜色*/
.btnBg {
	width: 13.6rem;
	height: 2rem;
	border-radius: 0.2rem;
	position: absolute;
	bottom: 1.6rem;
	left: 0.7rem;
	line-height: 2rem;
	font-size: 0.6rem;
	color: #fff;
	background: #fd3e3e;
	border: none;
}
.htmlBox {
	height: 100%;
	display: block;
	background: #fff;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	width: 100%;
}
.title {
	font-size: 0.96rem;
	color: #333333;
	font-weight: normal;
	margin: 1.4rem 0 0.6rem;
	text-align: center;
}
.tips {
	color: #999999;
	font-size: 0.56rem;
	margin: 0;
	text-align: center;
}
.userinfo {
	width: 15rem;
	padding-top: 1.2rem;
}
.userinfo ul {
	padding: 0 0.8rem;
}
.userinfo ul li {
	height: 1.6rem;
	line-height: 1.6rem;
	padding-top: 0.4rem;
}
.userinfo ul li p {
	float: left;
	font-size: 0.56rem;
	color: #333333;
	width: 3rem;
}
.userinfo ul li input {
	width: 8rem;
	float: left;
	border: none;
	font-size: 0.56rem;
	padding-left: 0.4rem;
}
.userinfo ul li input.w200 {
	width: 6rem !important;
}
.userinfo ul li em {
	width: 3.6rem;
	height: 1.4rem;
	background: #fd3e3e;
	border-radius: 0.2rem;
	color: #fff;
	line-height: 1.4rem;
	float: right;
	font-size: 0.56rem;
	font-style: normal;
	text-align: center;
}

.sure_btn {
	width: 13.6rem;
	height: 2rem;
	background: rgba(221, 221, 221, 1);
	border-radius: 0.2rem;
	position: absolute;
	bottom: 1.6rem;
	left: 0.7rem;
	line-height: 2rem;
	font-size: 0.6rem;
	color: #fff;
}
.active {
	background: #fd3e3e !important;
}
</style>
